export default {
  currentProjects: 'Aktuelle Aufträge',
  title: 'Auftrag',
  dynamicLists: 'dynamische Listen',
  receivedApplications: 'alle Bewerbungen',
  shortList: 'Shortlist',
  longList: 'Longlist',
  latecomerList: 'Nachzügler',
};
